<script>
    import Financials from '@/services/Financials';
    import Orders from '@/services/Orders';
    // import validationMessages from '@/components/validations'
    import {minLength, numeric, required, helpers} from "vuelidate/lib/validators";
    import Swal from "sweetalert2";

    export default {
   
     props: ['transactionId','legacy'],

        watch: {
            transactionData: function(newVal) {
                this.status_e = newVal.status;
            }
        },
        validations: {
            amount: {
                required,
              numericOrDecimal: helpers.regex('numericOrDecimal', /^[0-9]+(\.[0-9]{1,2})?$/)
            },
            reason: {
                required,
                minLength: minLength(2)
            },
        },
        data() {
            return {
                showModal: false,
                orderDetails:[],
                transactionDetails:[],
                transactionData:[],
                refundsData:[],
                isLoading: false, 
                isBusy: false,
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                filter: null,
                filterOn: [],
                sortBy: "date",
                sortDesc: false,
                csrf_token: localStorage.getItem('csrf_token'),
                status_e: '',
                oldStatus: '',
                amount: '',
                reason: '',
                tryingToEdit: false,
                submitted: false,
                submittedR: false,
                isDisabled: false,
              fields: [
                    {
                        key: "refund_id",
                        label: "Refund Id",
                    },
                    {
                        key: "balance_transaction",
                        label: "Balance Transaction",
                    },
                    {
                        key: "created",
                        label: "Created",
                        sortable: true,
                    },
                    {
                        key: "currency",
                        label: "Currency",
                    },
                    {
                        key: "amount",
                        label: "Amount",
                        sortable: true,
                    },
                    {
                        key: "reason",
                        label: "Reason",
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                    }
                ],
            };
        },
        computed:{
            rows() {
                return this.refundsData.length;
            },
             editTransactionTitle(){
                return 'Edit Transacation: ' + this.transactionData.transaction_id
            },
            oldStatusData(){
                return this.transactionData.status;
            }
        },
        methods: {
            resetModal() {
        this.transactionData = [];
        this.refundsData = [];
        this.amount = '';
        this.reason = '';
        this.submitted = false;
        this.submittedR = false;
        this.tryingToEdit = false;
        this.status_e = '';
        this.oldStatus = '';
        this.isLoading = false;
        this.isBusy = false;
    },

            async getTransactionDetails(){
                this.isLoading = true; 
                this.toggleBusy();
                await Financials.getTransaction(this.transactionId).then((response) => {
                    if (response.data.transaction && response.data.transaction.length > 0) {
            this.transactionData = response.data.transaction[0]; 
            this.refundsData = []; 
        } else {
            this.transactionData = {}; 
            this.refundsData = [];
        }
                }).catch(error => {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg(this.error)
                }).finally(() => {
                    this.isLoading = false; 
                    this.toggleBusy();
                })
            },
            closeModal() {
                this.showModal = false;
            },
        

           

       

            successmsg() {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Change has been saved",
                    showConfirmButton: false,
                    timer: 2000,
                });
            },

            failedmsg(msg) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: msg,
                    showConfirmButton: false,
                    timer: 5000,
                });
            },

            resetProps(){
                this.amount = '';
                this.reason = '';
                this.submitted = false;
                
            },

            refreshData() {
                this.$emit('onRefresh') //event from parent
            },

        }
    };
</script>

<template>
    <b-modal @shown="resetModal();getTransactionDetails()" v-model="showModal" id="view_transaction" title="View Transaction Details" title-class="font-18" size="xl" centered>
         <div class="row mb-3" v-if="isLoading">
            <div class="col-sm-12 text-center">
                <b-spinner label="Loading..."></b-spinner>
                <h4 class="font-size-16 mb-2">Loading transaction details...</h4>
            </div>
        </div>



        <div class="row mb-3" v-if="!Object.keys(transactionData).length  && !refundsData.length && !isLoading">
            <div class="col-sm-12">
                <h4 class="font-size-16 mb-2 text-center">
                    Transactions are synced every hour. Please try again later or contact support.
                </h4>
            </div>
        </div>

        <div class="row mb-3" v-else-if="Object.keys(transactionData).length > 0">
            <div class="col-sm-6">
               <p class="font-size-16 mb-2"><span class="text-strong">Transaction ID:</span> {{transactionData.transaction_id}}</p>
                <p class="font-size-16 mb-2"><span class="text-strong">Order ID:</span> {{transactionData.order_guid}}</p>
               <p class="font-size-16 mb-2"><span class="text-strong">Customer:</span>
                    <span v-if="transactionData.first_name || transactionData.last_name"> {{ transactionData.first_name + ' ' +  transactionData.last_name }}</span>
                </p>
               <p class="font-size-16 mb-2"><span class="text-strong">Email:</span> {{transactionData.email ? transactionData.email : 'N/A'}}</p>
               <p class="font-size-16 mb-2"><span class="text-strong">Phone:</span>{{transactionData.telephone ? transactionData.telephone : 'N/A'}}</p>
               <p class="font-size-16 mb-2"><span class="text-strong">City:</span> {{transactionData.city ? transactionData.city : 'N/A'}}</p>
               <p class="font-size-16 mb-2"><span class="text-strong">Zip:</span> {{transactionData.zip ? transactionData.zip : 'N/A'}}</p>
               <p class="font-size-16 mb-2"><span class="text-strong">Order Status:</span> <span class="font-size-16"
                  v-html="format_status(transactionData.status)"> </span></p>
            </div>
            <div class="col-sm-6">
                <p class="font-size-16 mb-2"><span class="text-strong">Currency:</span> {{transactionData.amount_currency}}</p>
                <p class="font-size-16 mb-2"><span class="text-strong">Amount:</span> {{transactionData.original_amount}}</p>
                <p class="font-size-16 mb-2"><span class="text-strong">Created:</span> {{transactionData.timestamp}}</p>
            </div>

            <hr>
        </div>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
        </template>
    </b-modal>
</template>